module.exports = __webpack_public_path__ + "static/media/mirna_diesel.71b43039.png";